import { render, staticRenderFns } from "./judgeTip.vue?vue&type=template&id=4ea511c7&"
import script from "./judgeTip.vue?vue&type=script&lang=js&"
export * from "./judgeTip.vue?vue&type=script&lang=js&"
import style0 from "./judgeTip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports